import _forEach from 'lodash/forEach'
import { Fragment } from 'react'
import { useSelector } from 'react-redux'

import {
  Avatar_1,
  Avatar_2,
  Avatar_3,
  Avatar_4,
  Avatar_5,
} from '../../assets/img'
import { Navigator } from '../containers/Navigators'

const Leaderboard = ({ civilisation }) => {
  // FIXME_Needs to be updated to dynamic data with data from the smart contract
  function getRandomInt(max) {
    return Math.floor(Math.random() * max)
  }
  const avatars = [Avatar_1, Avatar_2, Avatar_3, Avatar_4, Avatar_5]

  // Query and create an Array with the first 20 leaders
  const leaderboard = useSelector((state) => state.leaderboard.leaderboard)
  const leaders = []
  let i = 0
  _forEach(leaderboard, function (mp, leader) {
    i++
    if (i > 1 && i < 22) {
      leaders.push({ name: leader, rank: `${mp} MP` })
    } else return
  })

  return (
    <section
      id="scrollbar"
      className="mt-0 flex relative mx-auto w-full flex-col lg:flex-row p-3 md:px-2 lg:px-8 xl:px-10 lg:pt-0 pb-8 xl:pb-10 2xl:pb-14 overflow-auto gap-7 items-start"
    >
      <div className="w-full flex flex-col xl:flex-row lg:w-2/3 xl:w-4/5 pb-8">
        <div className="grid grid-flow-row gap-3 w-full xl:w-1/2">
          <div className="grid container__leaderboard--grid md:gap-2 2xl:gap-3 gap-y-2 items-center">
            <div className="col-start-3 text-gold pl-2">Galaktikan</div>
            <div className="col-start-4 text-gold">Collection Rank</div>
            {leaders.map((leader, i) => {
              const randomInt = getRandomInt(4)
              return (
                i < 10 && (
                  <Fragment key={i}>
                    <p className="text-white">#{i + 1}</p>
                    <div className="w-1/4 min-w-[40px] 2xl:min-w-[50px]">
                      <img
                        className="w-full aspect-[3/4] object-cover"
                        src={avatars[randomInt]}
                        alt="Avatar Portrait"
                      ></img>
                    </div>

                    <div className="pl-2">
                      <p className="text-white">{leader.name}</p>
                      <p className="text-gold md:pt-2">Titanium Level</p>
                    </div>
                    <p className="text-white pl-3">{leader.rank}</p>
                  </Fragment>
                )
              )
            })}
          </div>
        </div>
        <div className="grid grid-flow-row gap-3 w-full xl:w-1/2 xl:pt-0 xl:ml-0 pt-2 -ml-1">
          <div className="grid container__leaderboard--grid gap-2 items-center">
            <div className="col-start-3 text-gold hidden xl:block">
              Galaktikan
            </div>
            <div className="col-start-4 text-gold hidden xl:block">
              Collection Rank
            </div>
            {leaders.map((leader, i) => {
              const randomInt = getRandomInt(4)
              return (
                i >= 10 && (
                  <Fragment key={i}>
                    <p className="text-white">#{i + 1}</p>
                    <div className="w-1/4 min-w-[40px] 2xl:min-w-[50px]">
                      <img
                        className="w-full aspect-[3/4] object-cover"
                        src={avatars[randomInt]}
                        alt="Avatar Portrait"
                      ></img>
                    </div>

                    <div className="pl-2">
                      <p className="text-white">{leader.name}</p>
                      <p className="text-gold pt-2">Titanium Level</p>
                    </div>
                    <p className="text-white pl-3">{leader.rank}</p>
                  </Fragment>
                )
              )
            })}
          </div>
        </div>
      </div>
      <div className="pr-5 md:w-1/3 xl:w-1/5 hidden lg:flex justify-end sticky top-0">
        <Navigator civilisation={civilisation} />
      </div>
    </section>
  )
}

export default Leaderboard
